import { authService } from '@/services/api/auth.service';
import i18n from '@/i18n';
import { sharedHelper, sessionHelper, alertHelper } from '@/utils';
import { SESSION } from "@/constants";
import { authLoginModel } from "@/models/api/authLogin.model";
import { authRefreshModel } from "@/models/api/authRefresh.model";

const user = JSON.parse(localStorage.getItem('user'));

export const state = {
    status: {
        loggeduser: true,
        save: true,
    }, 
    user,
};

export const AUTH_MODULE = 'api/auth';

// ACTIONS
export const LOGIN = 'login';
export const REFRESH = 'REFRESH';
export const LOGOUT = 'logout';

export const LOGIN_OTP_REQUEST = 'loginOtpRequest';
export const LOGIN_OTP_VERIFY = 'loginOtpVerify';
export const FORGOT_PASSWORD_OTP_REQUEST = 'forgotPasswordOtpRequest';
export const FORGOT_PASSWORD_OTP_VERIFY = 'forgotPasswordOtpVerify';
export const RESET_PASSWORD_VERIFY = 'resetPasswordVerify';

// MUTATIONS
const REQUESTING = "requesting";
const LOGIN_SUCCESS = "loginSuccess";
const LOGOUT_SUCCESS = "logout";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REFRESH_SUCCESS = "refreshSuccess";

export const getters = {
    loggedIn(state) {
        return !!state.user
    },
};

export const actions = {
    [LOGIN_OTP_REQUEST] ({ commit }, { data }) {
        commit(REQUESTING, 'save');
        return authService
            .loginOtpRequest(data)
            .then((result) => {
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error')});
                commit(FAILURE, error);
            });
    },
    [LOGIN_OTP_VERIFY] ({ commit }, { data }) {
        commit(REQUESTING, 'save');
        return authService
            .loginOtpVerify(data)
            .then((result) => {
                commit(SUCCESS);
                if (result?.success) {
                    alertHelper.alertSuccess({message: i18n.t('message.loginSuccess')});
                    commit(LOGIN_SUCCESS, result);
                }
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error')});
                commit(FAILURE, error);
            });
    },
    [FORGOT_PASSWORD_OTP_REQUEST] ({ commit }, { data }) {
        commit(REQUESTING, 'save');
        return authService
            .forgotPasswordOtpRequest(data)
            .then((result) => {
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error')});
                commit(FAILURE, error);
            });
    },
    [FORGOT_PASSWORD_OTP_VERIFY] ({ commit }, { data }) {
        commit(REQUESTING, 'save');
        return authService
            .forgotPasswordOtpVerify(data)
            .then((result) => {
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error')});
                commit(FAILURE, error);
            });
    },
    [RESET_PASSWORD_VERIFY] ({ commit }, { data }) {
        commit(REQUESTING, 'save');
        return authService
            .resetPasswordVerify(data)
            .then((result) => {
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error')});
                commit(FAILURE, error);
            });
    },

    [LOGIN] ({ commit }, { data }) {
        commit(REQUESTING);
        return authService
            .login(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('message.loginSuccess')});
                commit(LOGIN_SUCCESS, result);
            })
            .catch((error) => {
                let message = sharedHelper.getErrorMessage(error);
                alertHelper.alertError({message: message, title: i18n.t('message.error')});
                commit(FAILURE, error);
            });
    },
    [REFRESH] ({ commit }, { data } = {}) {
        commit(REQUESTING);
        return authService
            .refresh(data)
            .then((result) => {
                commit(REFRESH_SUCCESS, result);
            })
            .catch((error) => {
                let message = sharedHelper.getErrorMessage(error);
                alertHelper.alertError({message: message, title: i18n.t('message.error')});
                commit(FAILURE, error);
                throw error;
            });
    },
    [LOGOUT] ({ commit }) {
        commit(LOGOUT_SUCCESS);
        // authService
        //     .logout()
        //     .then((result) => {
        //         console.log(result);
        //         alertHelper.alertSuccess({message: i18n.t('message.logoutSuccess')});
        //         commit(LOGOUT_SUCCESS);
        //     })
        //     .catch((error) => {
        //         let message = sharedHelper.getErrorMessage(error);
        //         alertHelper.alertError({message: message, title: i18n.t('message.error')});
        //         commit(FAILURE, error);
        //     });
    },
};

export const mutations = {
    [REQUESTING] (state, type) {
        if (type) {
            state.status[type] = false;
            return;
        }
        state.status = { loggeduser: false };  
    },
    [SUCCESS] (state) {
        state.status = { loggeduser: true, save: true };
    },
    [FAILURE] (state) {
        state.status = { save: true };
    },
    [LOGIN_SUCCESS] (state, data) {
        const user = authLoginModel(data.data);

        state.status = { loggeduser: true, save: true };
        state.user = user;

        var tokenExpiresAt = sessionHelper.calculateTime(user.token.expiresAt);
        var refreshExpiresAt = sessionHelper.calculateTime(user.token.refreshExpiresAt);

        localStorage.setItem(SESSION.JWT_TOKEN, user.token.accessToken);
        localStorage.setItem(SESSION.TOKEN_EXPIRY_TIME, tokenExpiresAt);
        localStorage.setItem(SESSION.REFRESH_TOKEN_EXPIRY_TIME, refreshExpiresAt);
        localStorage.setItem(SESSION.PERMISSIONS, JSON.stringify(user.user.permissions));
        localStorage.setItem(SESSION.USER_NAME, user.user.firstName + ' ' + user.user.lastName);
        localStorage.setItem(SESSION.USER, JSON.stringify(user));
        localStorage.setItem(SESSION.USER_TYPE, 'api');

        window.location.href = '/';
    },
    [LOGOUT_SUCCESS] (state) {
        sessionHelper.clearAllClientStorage()
        state.status = {};
        state.user = null;

        window.location.href = '/';
    },
    [REFRESH_SUCCESS] (state, data) {
        state.status = {};

        const token = authRefreshModel(data.data);
        const user = JSON.parse(localStorage.getItem(SESSION.USER));
        user.token = token;

        var tokenExpiresAt = sessionHelper.calculateTime(user.token.expiresAt);
        var refreshExpiresAt = sessionHelper.calculateTime(user.token.refreshExpiresAt);

        state.user = user;

        localStorage.setItem(SESSION.JWT_TOKEN, user.token.accessToken);
        localStorage.setItem(SESSION.TOKEN_EXPIRY_TIME, tokenExpiresAt);
        localStorage.setItem(SESSION.REFRESH_TOKEN_EXPIRY_TIME, refreshExpiresAt);
        localStorage.setItem(SESSION.USER_NAME, user.user.firstName + ' ' + user.user.lastName);
        localStorage.setItem(SESSION.USER, JSON.stringify(user));
        localStorage.setItem(SESSION.USER_TYPE, 'api');
    },
};
